var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.257 83.1107C129.629 71.9196 129.897 60.0225 127.033 48.6908C124.168 37.3591 118.278 27.0189 109.992 18.7753C101.706 10.5316 91.3357 4.69439 79.9895 1.8875C68.6434 -0.919387 56.7477 -0.590446 45.5741 2.83917C34.4004 6.26878 24.3686 12.6701 16.5509 21.3591C8.73328 30.0481 3.42359 40.698 1.18936 52.1707C-1.04487 63.6433 -0.119653 75.5075 3.86612 86.4951C7.85189 97.4827 14.7484 107.181 23.8186 114.553L25.2037 112.848C16.4424 105.727 9.78072 96.3596 5.93067 85.7461C2.08061 75.1327 1.18689 63.6725 3.34505 52.5905C5.5032 41.5084 10.6321 31.2211 18.1836 22.828C25.735 14.4349 35.4252 8.25152 46.2185 4.93868C57.0117 1.62584 68.5023 1.3081 79.4621 4.01942C90.4219 6.73073 100.439 12.3692 108.443 20.3322C116.447 28.2951 122.136 38.2833 124.903 49.2291C127.671 60.1749 127.412 71.667 124.154 82.477L126.257 83.1107Z",
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.5,
    cy: 81.5,
    r: 3.5,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI2);
export default __webpack_public_path__ + "static/media/i2.2268662964ef1aa82e3ace4b7ae5d7f9.svg";
export { ForwardRef as ReactComponent };